import { useAppSelector } from "@/app/store";

export type SqlDialect = "mysql" | "snowflake";

export function useSqlDialect(domainId: number | null | undefined): SqlDialect | undefined {
  return useAppSelector((state) => {
    if (!domainId) return undefined;
    const domain = state.domains.domains.find((d) => d.id === domainId);
    if (!domain) return undefined;
    const connection = state.connections.connections.find((c) => c.id === domain.connection_id);
    if (!connection) return undefined;
    const type = connection.type.toUpperCase();
    if (type === "MYSQL") return "mysql";
    if (type === "SNOWFLAKE") return "snowflake";
    return undefined;
  });
}
